export function appendSuffix(
	label: string,
	labelSuffix: string | undefined
): string {
	if (!labelSuffix) return label;

	return `${label} ${labelSuffix}`;
}
